import { render, staticRenderFns } from "./EditPropertyView.vue?vue&type=template&id=39b6be10&scoped=true"
import script from "./EditPropertyView.vue?vue&type=script&lang=js"
export * from "./EditPropertyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b6be10",
  null
  
)

export default component.exports